import { forwardRef } from 'react';
import { Input } from './fragments/Input';
import { formatIban, normalizeIban } from 'shared/utils/iban';

type IbanInputProps = {
  /** Valeur normalisée (majuscules, sans espaces) telle que stockée dans le formulaire. */
  value: string;
  /** Reçoit la valeur normalisée, jamais le texte affiché. */
  onChange: (normalized: string) => void;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'>;

/** Longueur max affichée : 34 caractères d'IBAN + 8 espaces de groupage. */
const MAX_DISPLAY_LENGTH = 34 + 8;

const DEFAULT_PLACEHOLDER = 'FR76 3000 1007 9412 3456 7890 185';

/**
 * Champ IBAN unique de la plateforme : la saisie s'affiche par groupes de 4
 * caractères, et `onChange` rend la valeur normalisée (majuscules, sans
 * espaces) — c'est elle qui est stockée dans le formulaire et envoyée au back.
 * Le collage avec ou sans espaces, en minuscules, est accepté tel quel.
 */
export const IbanInput = forwardRef<HTMLInputElement, IbanInputProps>(
  function IbanInput({ value, onChange, placeholder, ...props }, ref) {
    return (
      <Input
        ref={ref}
        {...props}
        value={formatIban(value)}
        onChange={e => onChange(normalizeIban(e.target.value))}
        inputMode="text"
        autoCapitalize="characters"
        spellCheck={false}
        maxLength={MAX_DISPLAY_LENGTH}
        placeholder={placeholder ?? DEFAULT_PLACEHOLDER}
      />
    );
  }
);
